// COPIA da TMA#718 di CriGio @ 18f1ef07d0fe7bf6a63c2730ac049e52c705f67e: src/lib/burraco/useVibrazione.ts — CAMBI (fase 2): un parametro facoltativo `preferenza` (se c'e', vale al posto di `settings.hapticsEnabled`; senza, comportamento identico all'originale)
import { useCallback, useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
import { hapticFeedback } from '@tma.js/sdk-react';

type Impatto = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type Notifica = 'error' | 'success' | 'warning';

/**
 * La vibrazione di Telegram per le mosse del tavolo: la stessa preferenza di `useHaptics` (`settings.hapticsEnabled`), ma TOLLERANTE: il tavolo si
 * monta anche senza lo store (nei test, in un banco), e allora semplicemente non vibra invece di rompersi. Fuori da Telegram non fa niente.
 * La preferenza si legge al momento della vibrazione, non a ogni disegno: il tavolo non si ridisegna per lei.
 * `preferenza` (fase 2): un gioco che ha la SUA (il Chinese Poker) la passa qui e quella vale al posto dello store; senza, vale lo store come prima.
 */
export function useVibrazione(preferenza?: boolean) {
  const ctx = useContext(ReactReduxContext);
  const acceso = useCallback(() => {
    if (preferenza !== undefined) return preferenza;
    const stato = ctx?.store.getState() as { settings?: { hapticsEnabled?: boolean } } | undefined;
    return stato?.settings?.hapticsEnabled === true;
  }, [ctx, preferenza]);
  const impact = useCallback(
    (stile: Impatto = 'light') => {
      if (!acceso()) return;
      try {
        hapticFeedback.impactOccurred(stile);
      } catch {
        /* fuori da Telegram */
      }
    },
    [acceso],
  );
  const notification = useCallback(
    (tipo: Notifica) => {
      if (!acceso()) return;
      try {
        hapticFeedback.notificationOccurred(tipo);
      } catch {
        /* fuori da Telegram */
      }
    },
    [acceso],
  );
  return { impact, notification };
}
